import { Box, Typography } from '@mui/material';
import { Button, Modal, ModalProps } from 'components/ui';
import React, { ReactElement, useEffect, useState } from 'react';
import { useProfileApi } from 'services/api';
import { useSnackbar } from 'notistack';
import { throttle } from 'lodash';

export interface LeaveOrganizationModalProps
  extends Pick<ModalProps, 'open' | 'onClose'> {
  organizationId: string;
}

export const LeaveOrganizationModal = ({
  open,
  onClose,
  organizationId,
}: LeaveOrganizationModalProps): ReactElement => {
  const [isSubmitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) setSubmitting(false);
  }, [open]);

  const profileApi = useProfileApi();

  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = throttle(
    async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitting(true);
      const result = await profileApi.leaveOrganization(organizationId);

      if (result.success) return onClose?.();

      setSubmitting(false);
      enqueueSnackbar(result.error.message, { variant: 'error' });
    },
    200,
    { leading: true },
  );

  return (
    <Modal title="Leave Organization?" open={open} onClose={onClose}>
      <form onSubmit={onSubmit}>
        <Typography>
          You will no longer be able to post events for this organization.
        </Typography>

        <Box mt={20} width="min(70vw, 685px)" display="flex">
          <Box mr={30}>
            <Button minWidth={100} inverted onClick={onClose}>
              Cancel
            </Button>
          </Box>
          <Button
            type="submit"
            minWidth={100}
            variant="vibrant"
            disabled={isSubmitting}
          >
            Leave
          </Button>
        </Box>
      </form>
    </Modal>
  );
};
